import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  NavLink,
  useNavigate,
  useMatch,
  useParams,
} from "react-router-dom";
import { modalActions } from "../storage/modals";
import DEFAULT_LOGO from "../assets/images/logo_white.svg";
import DEFAULT_LOGO_DARK from "../assets/images/logo_dark.svg";
import api from "../storage/api";

const Header = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const cartTotal = useSelector((state) => state.cart.totalAmount);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const siteContent = props.siteContent;

  const showMobileMenuHandler = () => {
    setShowMobileMenu((current) => !current);
  };

  const openPageHandler = (event, page) => {
    event.preventDefault();
    setShowMobileMenu(false);
    navigate(page);
  };

  const showCartHandler = () => {
    dispatch(modalActions.showCartModal());
  };

  const urlMatches = useMatch("/:server");

  const getLogoUrl = () => (urlMatches ? DEFAULT_LOGO : DEFAULT_LOGO_DARK);

  const plashka = siteContent?.logo ? (
    <img
      src={`${api.apiImages}${siteContent.logo}`}
      alt="RPM Server Logo"
      className="header-logo__image_plashka"
    />
  ) : null;

  return (
    <header className={urlMatches ? "header" : "header header_static"}>
      <div className="container">
        <div className="header-wrapper">
          <div className="header-left">
            <Link to={`/${params.server}`} className="header-logo">
              <img
                src={getLogoUrl()}
                alt="RPM Server Logo"
                className="header-logo__image"
              />
              {plashka}
            </Link>
            <nav className="header-nav">
              <NavLink
                to={`/${params.server}`}
                className={({ isActive }) =>
                  isActive
                    ? "header-nav__link header-nav__link_active"
                    : "header-nav__link"
                }
                end
              >
                Главная
              </NavLink>
              <NavLink
                to={`/${params.server}/products`}
                className={({ isActive }) =>
                  isActive
                    ? "header-nav__link header-nav__link_active"
                    : "header-nav__link"
                }
              >
                Все товары
              </NavLink>
              <NavLink
                to={`/${params.server}/deals`}
                className={({ isActive }) =>
                  isActive
                    ? "header-nav__link header-nav__link_active"
                    : "header-nav__link"
                }
              >
                Временные наборы
              </NavLink>
              <NavLink
                to={`/${params.server}/agreement`}
                className={({ isActive }) =>
                  isActive
                    ? "header-nav__link header-nav__link_active"
                    : "header-nav__link"
                }
              >
                Соглашение
              </NavLink>
            </nav>
            <div className="header-nav-mobile">
              <button
                type="button"
                className="header-nav-mobile__current"
                onClick={showMobileMenuHandler}
              >
                Главная
              </button>
              <div
                className="header-nav-mobile__links"
                style={showMobileMenu ? { display: "flex" } : undefined}
              >
                <a
                  href={`/${params.server}`}
                  className="header-nav__link"
                  onClick={(e) => openPageHandler(e, `/${params.server}`)}
                >
                  Главная
                </a>
                <a
                  href={`/${params.server}/products`}
                  className="header-nav__link"
                  onClick={(e) =>
                    openPageHandler(e, `/${params.server}/products`)
                  }
                >
                  Все товары
                </a>
                <a
                  href={`/${params.server}/deals`}
                  className="header-nav__link"
                  onClick={(e) => openPageHandler(e, `/${params.server}/deals`)}
                >
                  Временные наборы
                </a>
                <a
                  href={`/${params.server}/agreement`}
                  className="header-nav__link"
                  onClick={(e) =>
                    openPageHandler(e, `/${params.server}/agreement`)
                  }
                >
                  Соглашение
                </a>
              </div>
            </div>
          </div>
          <div className="header-right">
            <div className="header-socials">
              {/* <a
                href={siteContent.vk_link}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="header-socials__link header-socials__link_vk"
              >
                vk
              </a> */}
              <a
                href={siteContent.discord_link}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="header-socials__link header-socials__link_discord"
              >
                discord
              </a>
              <a
                href={siteContent.tiktok_link}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="header-socials__link header-socials__link_tiktok"
              >
                tiktok
              </a>
              <a
                href={siteContent.youtube_link}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="header-socials__link header-socials__link_youtube"
              >
                yt
              </a>
            </div>
            <button
              type="button"
              className="header-cart"
              onClick={showCartHandler}
            >
              <span className="header-cart__icon"></span>
              {cartTotal} &#8381;
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
